import(/* webpackMode: "eager" */ "/app/apps/webapp/src/app/[lang]/error.tsx");
